export const GET_FULLSTORY_FLAG = 'GET_FULLSTORY_FLAG'